// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "fc1c3ae7f7a0b3f8dca9" + ".chunk.js";
};